  
import React,{useEffect} from 'react';
import { connect } from 'react-redux';
// import {Route} from 'react-router-dom'
import CollectionItem from '../../components/collection-item/collection-item.component';
import { selectCollection } from '../../redux/shop/shop.selectors';
// import Item from '../../pages/item/item.component'
import './collection.styles.scss';
import {Helmet} from 'react-helmet'
import CustomButton from '../../components/custom-button/custom-button.component';
import { Link } from 'react-router-dom';

const CollectionPage = ({ collection,match}) => {
  const { title,metaTitle,mataDesc, items } = collection;
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <>
    {/* <Helmet>
      <meta charset="utf-8"/>
      <meta name="viewport" content="width=device-width, initial-scale=1"/>
      <meta name="description" content={mataDesc}/>
      <title>{metaTitle}</title>
    </Helmet> */}
    {
      collection.length===0 ? <div>No Items Found in this category</div> :
    <div className='collection-page'>
      <h2 className='title'>{title}</h2>
      <Link to="/shop">
      <CustomButton type="button">Back to Shop</CustomButton></Link>
      <h3 style={{color:"gray",opacity:".5"}}>{metaTitle}</h3>
      <div className='items'>
        {items.map(item => (
          <CollectionItem key={item.id} item={item} title={title} />
        ))}
      </div>
    </div>
    }
    </>
  );
};

const mapStateToProps = (state, ownProps) => ({
  collection: selectCollection(ownProps.match.params.collectionId)(state)
});

export default connect(mapStateToProps)(CollectionPage);